// extracted by mini-css-extract-plugin
module.exports = {"container":"FireflyGenerativeCreditsInfo_container__9SjVk","tooltip":"FireflyGenerativeCreditsInfo_tooltip__kg6Y_"};